import { makeAppSettings } from "@animech/axiom-format/src/definitions/definition-bindings";

export const appSettings = makeAppSettings({
	currency: "sek",
	locale: "en",
	manifest: "manifest.json",
	scene: {
		main: "2414718.json",
		environment: "2414718.json",
	},
});
